module.exports = __webpack_public_path__ + "img/img3.61cc6502.jpg";